import React from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import { APP_ROOT_ID } from './constants/dom'
import './components/Admin/admin.css'
import { initFaro } from './integrations/faro'
import * as serviceWorker from './serviceWorker'

// Initialize browser RUM before mount so page-load metrics are captured.
initFaro()

const container = document.getElementById(APP_ROOT_ID)
if (!container) throw new Error(`Missing #${APP_ROOT_ID} mount node`)
const root = createRoot(container)
root.render(<App />)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
